import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Size } from '../../domain/entities/Size';
import { SelectedSizeBoxTheme, SizeBoxTheme } from '../../../theme/default-theme';
import { ContentSpacing, breakpoint } from 'elc-base-theme';

export interface ISelected {
    isSelected: boolean;
}

export interface ISizeBox {
    size: Size;
    isSelected: boolean;
    onSelect?(name: string, productId: string): void;
    productId: string;
}

const StyledBox = styled.span`
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    white-space: nowrap;
    border: 0.5px solid;
    border-radius: 5px;
    text-align: center;
    padding: ${ContentSpacing.space8} ${ContentSpacing.space12};
    margin: ${ContentSpacing.space12} ${ContentSpacing.space12} ${ContentSpacing.space12} 0;
    cursor: pointer;
    ${(props: ISelected) => (props.isSelected ? SelectedSizeBoxTheme : SizeBoxTheme)};
    [dir='rtl'] & {
        margin: ${ContentSpacing.space12} 0 ${ContentSpacing.space12} ${ContentSpacing.space12};
    }

    ${breakpoint('desktop')`
        width: initial;
    `};
`;

export const ProductSizeBox = observer((props: ISizeBox) => {
    const { isSelected, onSelect, productId } = props;
    const { value } = props.size;
    const SizePickerBoxClassNames = 'elc-size-picker-box js-size-picker-box';
    const SizePickerBoxClassNamesSelected =
        'elc-size-picker-box-selected js-size-picker-box-selected';

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (onSelect) {
            onSelect(value, productId);
        }
    };

    return (
        <StyledBox
            className={isSelected ? SizePickerBoxClassNamesSelected : SizePickerBoxClassNames}
            onClick={handleClick}
            isSelected={isSelected}
        >
            {value}
        </StyledBox>
    );
});
